import { createStyles, Theme } from '@mui/material'

const styles = ({ spacing }: Theme) =>
  createStyles({
    formControl: {
      marginTop: spacing(2),
      marginBottom: spacing(2),
    },
    submitContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: spacing(2),
      marginBottom: spacing(2),
    },
    divider: {
      marginTop: spacing(3),
      marginBottom: spacing(3),
    },
    field: {
      marginBottom: spacing(2),
    },
    extraField: {
      marginBottom: spacing(3),
    },
    gender: {
      marginTop: spacing(),
      marginBottom: spacing(),
    },
    genderLabel: {
      marginBottom: spacing(),
    },
    genderInput: {
      flexDirection: 'row',
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: spacing(10),
    },
    formSection: {
      marginBottom: spacing(2),
    },
    sectionList: {
      marginTop: spacing(2),
    },
    sectionForm: {
      marginBottom: spacing(2),
    },
    footerContainer: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '100%',
      background: 'white',
    },
    footerSelector: {
      padding: spacing(2),
      paddingTop: spacing(),
    },
  })

export default styles
